import axios from 'axios';
import Multiselect from 'vue-multiselect';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import showConfirmation from '@waypoint/vue-confirmation';
import showAlert from '@waypoint/vue-alert';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import SimpleMap from '@/components/global/simple-map/SimpleMap.vue';
import moment from 'moment';

import tripsEscl from '@/locales/es-CL/trips.json';
import tripsEsmx from '@/locales/es-MX/trips.json';
import tripsEsco from '@/locales/es-CO/trips.json';
import tripsEnus from '@/locales/en-US/trips.json';

export default {
  name: 'TripBuilder',
  components: {
    Multiselect,
    GoogleMapsApiLoader,
    BuscadorDirecciones,
    SimpleMap,
  },
  props: {
    tripId: {
      type: String,
      default: null,
    },
    originId: Number,
    currentRoute: Object,
  },
  i18n: {
    messages: {
      'es-CL': { trips: tripsEscl },
      'es-MX': { trips: tripsEsmx },
      'es-CO': { trips: tripsEsco },
      'en-US': { trips: tripsEnus },
    },
  },
  data() {
    return {
      changeDestination: false,
      form: this.setForm(),
      activities: [],
      tripInfo: null,
      destinations: [],
      launched: false,
      spotDefinitiveChecked: false,
      temporalSpotRequired: false,
      isTemporalSpotBusy: false,
      spotTypeList: [],
      spotTypeSelected: null,
      countryList: [],
      countrySelected: null,
      businessList: [],
      businessSelected: null,
      launchedCalculate: false,
      selectedDestination: null,
      timeTrip: null,
      showTimeTrip: true,
      isFilterApplied: false,
      estimatedData: null,
      editTimeTrip: false,
      estimated: false,
      estimatedTrip: '',
      showbuttons: true,
      extraInfo: null,
      spotForm: {
        address: {
          city: null,
          postalCode: null,
          state: null,
          street: '',
          lat: null,
          lon: null,
          country: {
            id: null,
          },
        },
        category: null,
        comments: null,
        contacts: [],
        description: null,
        legalNumber: null,
        legalName: null,
        name: null,
        schedule: [],
        type: 'Temporal',
        zone: [],
      },
      gapi: null,
      isRouteEditable: false,
    };
  },
  async created() {
    console.log("ID DE ORIGEN ",this.originId);
    this.launched = true;

    GoogleMapsApiLoader({
      libraries: ['places'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    if (!this.originId) {
      //Si se refresca la vista el originId queda nulo, por lo tanto para evitar fallos se devuelve a la vista de routeBuilder
      this.$router.push({ name: 'RouteBuilder', params: { routeId: this.getStoredItem('routeBuilderRouteId') } });
    }
    await this.creationSteps();
    if (
      this.currentRoute &&
      (this.currentRoute.state == 'PARTIALLYASSIGNED' ||
        this.currentRoute.state == 'ASSIGNED' ||
        this.currentRoute.state == 'ONGOING')
    ) {
      this.isRouteEditable = false;
    } else {
      this.isRouteEditable = true;
    }
    this.launched = false;
  },
  methods: {
    async editTime() {
      this.timeTrip = this.estimatedTrip;
      this.estimated = false;
      this.editTimeTrip = true;
    },
    async calculateTime() {
      this.cleanTime();
      this.estimated = true;
      this.launchedCalculate = true;
      await this.onChangeDestination();
      this.launchedCalculate = false;
    },
    cleanTime() {
      this.editTimeTrip = false;
      this.timeTrip = null;
    },
    async onChangeDestination() {
      this.cleanTime();
      this.showbuttons = true;

      if (this.form.destination) {
        let result = `${this.$store.getters.urlAPI}/trip/estimated?`;
        let isAnotherFilterPresent = false;
        this.isFilterApplied = false;
        let idRouteEst = this.tripInfo
          ? Number(this.tripInfo.idRoute)
          : Number(this.getStoredItem('routeBuilderRouteId'));
        if (idRouteEst) {
          result = isAnotherFilterPresent ? result + '&' + `idRoute=${idRouteEst}` : result + `idRoute=${idRouteEst}`;
          isAnotherFilterPresent = true;
          this.isFilterApplied = true;
        }
        if (this.originId) {
          result = isAnotherFilterPresent
            ? result + '&' + `idOriginFilter=${this.originId}`
            : result + `idOriginFilter=${this.originId}`;
          isAnotherFilterPresent = true;
          this.isFilterApplied = true;
        }
        if (this.form.destination && this.form.destination.id) {
          result = isAnotherFilterPresent
            ? result + '&' + `idDestinationFilter=${this.form.destination.id}`
            : result + `idDestinationFilter=${this.form.destination.id}`;
          isAnotherFilterPresent = true;
          this.isFilterApplied = true;
        }
        try {
          const config = {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          };
          let estimatedPromise = await this.axios.get(result, config);
          this.estimatedData = estimatedPromise.data.data;
          this.estimated = true;
          this.estimatedTrip = (this.estimatedData.drivingTime / 60).toFixed(2);
          console.log('estimated:', this.estimatedData);
        } catch (e) {
          console.log(e);
          return [];
        }
      } else {
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('trips.tripBuilder.modals.errorEstimated'));
      }
    },
    process() {
      if (this.timeTrip !== null) {
        this.$refs['editTime'].show();
      } else {
        this.save();
      }
    },
    clean() {
      this.timeTrip = null;
    },
    async creationSteps() {
      localStorage.removeItem('routeBuilderTripId');
      localStorage.removeItem('routeBuilderActivityId');
      localStorage.removeItem('routeBuilderDocumentId');
      localStorage.removeItem('routeBuilderItemId');
      if (this.tripId) {
        localStorage.setItem('routeBuilderTripId', this.tripId);
      }
      this.form = this.setForm();
      await this.getDestinations();
      await this.getSpotType();
      await this.getCountryList();
      if (this.tripId) {
        await this.getTripInfo();
        this.form = this.setForm();
        await this.handleDestinationChange();
        this.launched = true;
        this.showTimeTrip = true;
      }
      this.launched = false;
    },
    async getTripInfo() {
      try {
        const response = await axios.get(this.$store.getters.urlAPI + '/trip/' + this.tripId, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.tripInfo = response.data.data;
        if(this.tripInfo && this.tripInfo.extraData && Object.keys(this.tripInfo.extraData).length > 0){
          for (const value of Object.values(this.tripInfo.extraData)) {
            this.extraInfo = value.toString();
        }
        }
        this.activities = this.tripInfo.activities ? this.tripInfo.activities.sort((a, b) => a.id - b.id) : [];
      } catch (e) {
        this.tripInfo = null;
        this.activities = [];
      }
    },
    async getDestinations() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/spot/temporal?withAllTemporal=false`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.destinations = response.data.data;
      } catch (e) {
        this.destinations = [];
      }
    },
    setForm() {
      return {
        destination:
          this.tripInfo && this.tripInfo.destination
            ? this.destinations.find((d) => d.id === this.tripInfo.destination.id)
            : null,
      };
    },

    secondsToTimeString(seconds) {
      let currentDate = new Date();
      currentDate.setSeconds(0);
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate = new Date(currentDate.getTime() + seconds * 1000);
      return currentDate.toLocaleTimeString('en-US', { hour12: false });
    },
    timeStringToSeconds(timeString) {
      let values = timeString.split(':');
      if (values.length === 3) {
        let amount = Number(values[2]);
        amount += Number(values[1] * 60);
        amount += Number(values[0] * 60 * 60);
        return amount;
      } else {
        return 0;
      }
    },
    async save() {
      this.launched = true;
      try {
        if (this.validation()) {
          let body;
          if (this.timeTrip === null) {
            body = {
              idRoute: this.tripInfo
                ? Number(this.tripInfo.idRoute)
                : Number(this.getStoredItem('routeBuilderRouteId')),
              status: 1,
              editTime: Math.round(Number(this.estimatedTrip * 60)), // Se envia el estimado al servicio del back
              destination: this.form.destination.id
                ? {
                    id: this.form.destination.id,
                  }
                : null,
            };
          } else {
            body = {
              idRoute: this.tripInfo
                ? Number(this.tripInfo.idRoute)
                : Number(this.getStoredItem('routeBuilderRouteId')),
              status: 1,
              editTime: Math.round(Number(this.timeTrip * 60)),
              destination: this.form.destination.id
                ? {
                    id: this.form.destination.id,
                  }
                : null,
            };
          }
          if(this.extraInfo){
            body = {
              ...body,
              extraData: {
                extraData1: this.extraInfo,
              }
            }
          }
          if (!this.tripId) {
            const response = await axios.post(`${this.$store.getters.urlAPI}/trip`, body, {
              headers: {
                'id-client': this.$store.getters.clientId,
                Authorization: `Bearer ${this.$store.getters.accessToken}`,
              },
            });
            await this.invalidateCache();
            showAlert(
              this.$t('common.modals.exitoTitulo'),
              this.$t('trips.tripBuilder.modals.exitoAgregar'),
              'success',
              () => {
                this.$router.push({
                  name: 'TripBuilder',
                  params: {
                    tripId: response.data.data.id.toString(),
                    originId: this.originId,
                    currentRoute: this.currentRoute,
                  },
                });
              },
              undefined,
              this.$t('common.cruds.aceptar'),
            );
          } else {
            body.id = Number(this.tripId);
            await axios.patch(`${this.$store.getters.urlAPI}/trip/${this.tripId}`, body, {
              headers: {
                'id-client': this.$store.getters.clientId,
                Authorization: `Bearer ${this.$store.getters.accessToken}`,
              },
            });
            await this.invalidateCache();
            this.getTripInfo();
            showAlert(
              this.$t('common.modals.exitoTitulo'),
              this.$t('trips.tripBuilder.modals.exitoEditar'),
              'success',
              undefined,
              undefined,
              this.$t('common.cruds.aceptar'),
            );
            this.launched = false;
          }
        } else {
          this.launched = false;
        }
      } catch (e) {
        this.launched = false;
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('trips.tripBuilder.modals.error'),
          'error',
          undefined,
          undefined,
          this.$t('common.cruds.aceptar'),
        );
      }
    },
    clearSpotDataDetail() {
      this.spotForm.name = null;
      this.spotForm.legalName = null;
      this.spotForm.legalNumber = null;
      this.spotForm.type = null;
    },
    validationSpot() {
      if (this.spotDefinitiveChecked) {
        return (
          this.validateSpotAddress() &&
          this.validateSpotCountry() &&
          this.validateSpotState() &&
          this.validateSpotCity() &&
          this.validateSpotName() &&
          this.validateSpotType() &&
          this.validateSpotLegalNumber()
        );
      } else {
        return (
          this.validateSpotAddress() &&
          this.validateSpotCountry() &&
          this.validateSpotState() &&
          this.validateSpotCity()
        );
      }
    },
    validateSpotAddress() {
      const result = this.spotForm.address.street !== '';
      if (result) {
        return true;
      } else {
        this.showPopover('address');
        return false;
      }
    },
    validateSpotCountry() {
      const result = this.countrySelected !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('country');
        return false;
      }
    },
    validateSpotState() {
      const result = this.spotForm.address.state !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('state');
        return false;
      }
    },
    validateSpotCity() {
      const result = this.spotForm.address.city !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('city');
        return false;
      }
    },
    validateSpotName() {
      const result = this.spotForm.name !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('spotName');
        return false;
      }
    },
    validateSpotType() {
      const result = this.spotTypeSelected !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('spotName');
        return false;
      }
    },
    validateSpotLegalNumber() {
      const result = this.spotForm.legalNumber !== null;
      if (result) {
        return true;
      } else {
        this.showPopover('spotId');
        return false;
      }
    },
    validation() {
      return this.validateDestination();
    },
    validateDestination() {
      if (this.form.destination) {
        if (this.form.destination.id) {
          return this.destinations.filter((d) => d.id == this.form.destination.id).length > 0;
        }
      }
      this.showPopover('fldDestination');
      return false;
    },
    async handleDestinationChange() {
      this.launched = true;
      if (this.form.destination && this.form.destination.id === -1) {
        this.temporalSpotRequired = true;
      } else if (this.form.destination) {
        await this.retrieveDestination(this.form.destination.id);
      } else {
        this.selectedDestination = null;
      }
      if (this.tripInfo === null || this.changeDestination) {
        console.log('nuevo trip, calculo tiempo estimado');
        await this.onChangeDestination();
        this.changeDestination = false;
      } else {
        console.log('viejo trip, mantengo el tiempo estimado');
        this.estimatedTrip = (this.tripInfo.drivingTime / 60).toFixed(2);
      }
      this.estimated = true;
      this.launched = false;
    },
    clearIndicators() {
      const keys = Object.keys(this.indicators);
      keys.forEach((key) => {
        this.indicators[key] = '';
      });
    },
    async retrieveDestination(id) {
      try {
        const response = await axios.get(this.$store.getters.urlAPI + '/api/spot/' + id, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.selectedDestination = response.data.data;
      } catch (e) {
        this.selectedDestination = [];
      }
    },

    queryRemoval(id) {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('trips.tripBuilder.modals.confirmacionEliminar'),
        () => {
          this.removeActivity(id);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    editActivity(id) {
      this.$router.push({
        name: 'ActivityBuilder',
        params: { activityId: id.toString(), currentTrip: this.tripInfo, currentRoute: this.currentRoute },
      });
    },
    addActivity() {
      if (this.tripId) {
        this.$router.push({
          name: 'ActivityBuilder',
          params: { currentTrip: this.tripInfo, currentRoute: this.currentRoute },
        });
      } else {
        showConfirmation(
          this.$t('common.modals.confirmacionTitulo'),
          this.$t('trips.tripBuilder.modals.confirmacionGuardar'),
          () => {
            this.save();
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
        );
      }
    },

    showPopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::show::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::hide::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    async invalidateCache() {
      const invalidations = [];
      invalidations.push(
        axios.get(this.$store.getters.urlAPI + '/route/invalidate', {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        }),
      );
      invalidations.push(
        axios.get(this.$store.getters.urlAPI + '/trip/invalidate', {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        }),
      );
      await Promise.all(invalidations);
    },

    async removeActivity(id) {
      this.activities = this.activities.filter((activity) => activity.id !== id);
      await axios.delete(this.$store.getters.urlAPI + '/activity/' + id, {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      });

      await this.invalidateCache();
    },
    checkFormDiferences() {
      const currentForm = this.form;
      const originalForm = this.setForm();
      const keys = Object.keys(currentForm);
      for (const key of keys) {
        if (currentForm[key] !== originalForm[key]) {
          if (typeof currentForm[key] === 'object') {
            if (JSON.stringify(currentForm[key]) !== JSON.stringify(originalForm[key])) {
              return true;
            }
          } else {
            return true;
          }
        }
      }
      return false;
    },
    getStoredItem(key) {
      return localStorage.getItem(key);
    },
    checkClientSpot() {
      this.spotForm.legalName = null;
      this.spotForm.legalNumber = null;

      const client = this.$store.getters.client;

      this.spotForm.type = this.spotTypeSelected;

      if (this.spotForm.type === 'Sede propia') {
        this.spotForm.legalNumber = client.legalNumber;
        this.spotForm.legalName = client.legalName;
      } else if (this.spotForm.type === 'Cliente') {
        this.spotForm.legalNumber = null;
        this.spotForm.legalName = null;
        this.businessSelected = null;
        this.getBusinessList();
      } else if (this.spotForm.type === 'Otro') {
        this.spotForm.legalName = client.legalName;
      }
    },
    setBusiness() {
      this.spotForm.legalNumber = this.businessSelected.legalNumber;
      this.spotForm.legalName = this.businessSelected.legalName;
    },
    async getBusinessList() {
      this.isLoadingBusiness = true;
      var url = `${this.$store.getters.urlAPI}/api/business/`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(url, config);
        this.businessList = response.data.data;
      } catch (error) {
        console.log(`${error}, Ha ocurrido un error.`);
      }
    },
    async createTemporalSpot() {
      this.isTemporalSpotBusy = true;
      var spot = null;
      if (this.validationSpot()) {
        await this.prepareSpotBody();
        spot = await this.createSpot();
        if (this.spotForm.type === 'Cliente' && spot !== null) {
          await this.createSpotBusiness(spot.id);
        }

        if (spot !== null) {
          await this.getDestinations();
          this.form.destination = this.destinations.find((destination) => spot.id === destination.id);
          this.selectedDestination = this.form.destination;
        }
      }
      this.isTemporalSpotBusy = false;
      if (spot !== null) {
        this.closeModal('create-temporal-spot-modal');
        showAlert(
          this.$t('trips.tripBuilder.modals.tituloExito'),
          this.$t('trips.tripBuilder.modals.mensajeExitoCreacionSpot'),
          'success',
          undefined,
          undefined,
          this.$t('common.cruds.aceptar'),
        );
      }
    },
    async createSpot() {
      try {
        const url = `${this.$store.getters.urlAPI}/api/spot`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, this.spotForm, config);

        if (response.data.status) {
          return response.data.data;
        }
      } catch (error) {
        this.isSaving = false;

        if (error.response.status === 500) {
          var rawJson = '' + error.response.data;

          //Se obtiene la hora en que ocurre el error.
          const eventTime = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss');

          //Se controla error en caso de que el nombre de la ubicacion ya exista.
          if (
            rawJson.includes(
              'ERROR: duplicate key value violates unique constraint "name_id_client_deleted_at_null_idx"',
            )
          ) {
            showAlert(
              'Error: ' + this.$t('trips.tripBuilder.modals.nameSpot'),
              this.$t('trips.tripBuilder.modals.spotDuplicated') + ' [' + eventTime + ']',
              'error',
            );
          }

          //Cualquier error no controlado
          showAlert(
            'Error ' + error.response.status,
            this.$t('trips.tripBuilder.modals.spotUnexpectedError') + ' [' + eventTime + ']',
            'error',
          );
        }
        return null;
      }
    },
    async createSpotBusiness(spotId) {
      try {
        const body = {
          idSpot: spotId,
          idBusiness: this.businessSelected.id,
          idClient: this.$store.getters.clientId,
        };
        const url = `${this.$store.getters.urlAPI}/api/spot/spotBusiness`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(url, body, config);
        console.log(response.data.status);
      } catch (error) {
        console.log('error', error);
      }
    },
    async prepareSpotBody() {
      const now = new Date().getTime();
      const actualDate = new Date(now).toISOString().split('T')[0];
      var counterTemporalSpot = 0;
      this.destinations.forEach((destination) => {
        if (destination.type === 'Temporal') {
          counterTemporalSpot++;
        }
      });
      this.spotForm.zone = [
        {
          lat: this.spotForm.address.lat,
          lon: this.spotForm.address.lon,
          radio: 100,
        },
      ];
      let completeAdress =
        this.spotForm.address.street + ', ' + this.spotForm.address.city + ', ' + this.spotForm.address.state;
      console.log('calle', completeAdress);
      if (!this.spotDefinitiveChecked) {
        this.spotForm.name = `${completeAdress}_${actualDate}_${counterTemporalSpot}`;
        this.spotForm.legalName = `${completeAdress}_${actualDate}_${counterTemporalSpot}`;
        this.spotForm.legalNumber = `${completeAdress}_${actualDate}_${counterTemporalSpot}`;
        this.spotForm.type = 'Temporal';
      }
    },
    async getSpotType() {
      const url = `${this.$store.getters.urlAPI}/api/enum?type=spot_type`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(url, config);
        this.spotTypeList = response.data.data;

        const index = this.spotTypeList.indexOf('Temporal');
        if (index > -1) {
          this.spotTypeList.splice(index, 1);
        }
      } catch (error) {
        console.log(`${error}, Ha ocurrido un error.`);
      }
    },
    async getCountryList() {
      var url = `${this.$store.getters.urlAPI}/api/country`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const response = await axios.get(url, config);
      response.data.data.forEach((element) => {
        this.countryList.push({
          id: element.id,
          name: element.name,
          iso: element.iso,
        });
      });
      if (this.countryList.length > 0) {
        console.log('Listado de paises listo!');
        this.sortCountryList();
      } else {
        console.log('Listado de paises no listo. No se pueden crear ordenes!');
      }
    },
    sortCountryList() {
      this.countryList.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a y b son iguales.
        return 0;
      });
    },
    customForm(option) {
      if (option === 'state') {
        if (this.countrySelected !== null) {
          if (this.countrySelected.iso === 'CL') {
            return this.$t('trips.tripBuilder.modals.region');
          }

          if (this.countrySelected.iso === 'MX') {
            return this.$t('trips.tripBuilder.modals.delegation');
          }
        }
        return this.$t('trips.tripBuilder.modals.state');
      }
      if (option === 'city') {
        if (this.countrySelected !== null) {
          if (this.countrySelected.iso === 'CL') {
            return this.$t('trips.tripBuilder.modals.comuna');
          }

          if (this.countrySelected.iso === 'MX') {
            return this.$t('trips.tripBuilder.modals.colony');
          }
        }
        return this.$t('trips.tripBuilder.modals.city');
      }
    },
    async receiveAddressInformation(addressInfo) {
      if (addressInfo.streetName !== '') {
        console.log(addressInfo);
        this.countrySelected = addressInfo.iso.length === 0 ? '' : await this.getCountryByIso(addressInfo.iso);
        this.spotForm.address.city = addressInfo.city;
        this.spotForm.address.state = addressInfo.state;
        this.spotForm.address.street =
          addressInfo.number !== undefined ? addressInfo.streetName + ' ' + addressInfo.number : addressInfo.streetName;
        this.spotForm.address.lat = addressInfo.coordinates.lat;
        this.spotForm.address.lon = addressInfo.coordinates.lng;
        this.spotForm.address.country = {
          id: this.countrySelected.id,
        };
        const coordinates = [
          {
            position: {
              lat: this.spotForm.address.lat,
              lng: this.spotForm.address.lon,
            },
          },
        ];
        this.$refs.map.setSpot(coordinates);
        this.$refs.map.createGeoreference(true, 100);
      }
    },
    getCountryByIso(countryIso) {
      let countryMatched = null;
      this.countryList.forEach((element) => {
        if (countryIso === element.iso) {
          countryMatched = element;
        }
      });
      return countryMatched;
    },
    cleanSpotForm() {
      this.spotForm = {
        address: {
          city: null,
          postalCode: null,
          state: null,
          street: '',
          lat: null,
          lon: null,
          country: {
            id: null,
          },
        },
        category: null,
        comments: null,
        contacts: [],
        description: null,
        legalNumber: null,
        legalName: null,
        name: null,
        schedule: [],
        type: 'Temporal',
        zone: [],
      };
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    hideError(originalReference) {
      if (originalReference === this.errorReference) {
        this.errorReference = null;
      }
    },
  },
  computed: {
    renderedDestinations() {
      return [
        {
          id: -1,
          name: this.$t('trips.tripBuilder.otros.crearNuevoDestino'),
          addressStreet: null,
        },
        ...this.destinations,
      ];
    },
    renderedAddress() {
      if (this.selectedDestination && this.selectedDestination.address) {
        return this.selectedDestination.address.street;
      } else {
        return '';
      }
    },
    renderedNumber() {
      if (this.selectedDestination && this.selectedDestination.address.addressComplement) {
        return this.selectedDestination.address.addressComplement;
      } else {
        return '';
      }
    },
    renderedCity() {
      if (this.selectedDestination && this.selectedDestination.address) {
        return this.selectedDestination.address.city;
      } else {
        return '';
      }
    },
    renderedState() {
      if (this.selectedDestination && this.selectedDestination.address) {
        return this.selectedDestination.address.state;
      } else {
        return '';
      }
    },
    renderedCountry() {
      if (this.selectedDestination && this.selectedDestination.address && this.selectedDestination.address.country) {
        return this.selectedDestination.address.country.name;
      } else {
        return '';
      }
    },
    renderedStartDate() {
      if (this.tripInfo && this.tripInfo.startDate) {
        return moment(this.tripInfo.startDate).format('DD/MM - HH:mm [hrs.]');
      } else {
        return '';
      }
    },
    renderedEndDate() {
      if (this.tripInfo && this.tripInfo.endDate) {
        return moment(this.tripInfo.endDate).format('DD/MM - HH:mm [hrs.]');
      } else {
        return '';
      }
    },
    renderedContactName() {
      if (this.selectedDestination && this.selectedDestination.contacts && this.selectedDestination.contacts.length) {
        const { firstName, lastName } = this.selectedDestination.contacts[0];
        return `${firstName} ${lastName}`;
      } else {
        return '';
      }
    },
    renderedContactPhone() {
      if (
        this.selectedDestination &&
        this.selectedDestination.contacts &&
        this.selectedDestination.contacts.length &&
        (this.selectedDestination.contacts[0].phoneNumber1 || this.selectedDestination.contacts[0].phoneNumber2)
      ) {
        return this.selectedDestination.contacts[0].phoneNumber1 || this.selectedDestination.contacts[0].phoneNumber2;
      } else {
        return '';
      }
    },
    renderedContactMail() {
      if (this.selectedDestination && this.selectedDestination.contacts && this.selectedDestination.contacts.length) {
        return this.selectedDestination.contacts[0].email;
      } else {
        return '';
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.launched && this.checkFormDiferences()) {
      const answer = window.confirm(this.$t('common.cruds.pendingChanges'));
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  watch: {
    tripId() {
      this.creationSteps();
    },
    temporalSpotRequired: function () {
      if (this.temporalSpotRequired) {
        this.cleanSpotForm();
        this.showModal('create-temporal-spot-modal');
        this.isTemporalSpotBusy = false;
        this.temporalSpotRequired = false;
      }
    },
  },
};
